import { Navbar } from '../Navigation/Navbar';

export const App = () => {
	return <Navbar />;
};
